import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { getInfoBulleMessage, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import { createQueryIndus, getSpatialFilter, requestForIndus } from '../../../utils/helpers/module/indusHelper';
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import DoubleFilter from '../component/DoubleFilter';
import SingleFilter from '../component/SingleFilter';
import { domesticOptionsIndus } from '../options/optionsHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersIndus = (props: any) => {
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('indus_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('indus_commune')!) || {
      name: '',
      code: '',
      paths: '',
    }
  );
  const [domestic, setDomestic] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('indus_domestic')!) || {
      name: '',
      code: '',
    }
  );
  const [section, setSection] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('indus_section')!) || {
      name: '',
      code: '',
    }
  );
  const [activity, setActivity] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('indus_activity')!) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [sectionOptions, setSectionOptions] = useState<any>([]);
  const [activityOptions, setActivityOptions] = useState<any>([]);
  const [, setAllInseeCodesContract] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const infoBulleMessageDataSelectorIndus = getInfoBulleMessage(props.module);
  
  // feed main activity option unique values
  const prepareOptionsSection = (data: any) => {
    let options: any[] = [];
    data.forEach((raw: any) => {
      options.push({
        name: raw.SectionLabel,
        code: raw.SectionLabel.replaceAll("'", "''"),
      });
    });
    setSectionOptions(options);
    return options;
  };

  //get pour récupérer la liste des communes et des activités principales
  const getOptionsSections = async (
    pFilters: object,
    pAllInseeCodesContract: any[]
  ) => {
    let query: string = '';
    let data: any[] = [];
    let spatialFilter: any = getSpatialFilter(
      pFilters,
      pAllInseeCodesContract
    );
    if (spatialFilter.mode !== 'collectionPool') {
      let filtersIndus = defineDefinitionExpression(pFilters, 'indus', '');
      if (filtersIndus === '') {
        // no filters to add, only spatial filter
        query = spatialFilter.spatialFilter;
      } else {
        query = spatialFilter.spatialFilter + ' AND ' + filtersIndus;
      }
    } else {
      // collectionPool selected
      query = defineDefinitionExpression(pFilters, 'indus', '');
    }
    const formBodyToSend = createQueryIndus(
      query,
      'SectionLabel',
      spatialFilter.inputGeom
    );
    data = await requestForIndus(formBodyToSend, 'SectionLabel');
    return prepareOptionsSection(data);
  };

  // get installs options
  const getSection = async (
    pFilters: object,
    pAllCommunes: any[]
  ) => {
    const res = await getOptionsSections(
      pFilters,
      pAllCommunes
    );
    if (res.length === 0) {
      resetImputLabel('indus-filtre-section');
    }
    setSectionOptions(res);
  };

  //get pour récupérer la liste des communes et des activités principales
  const getOptionsActivity = async (
    pFilters: object
  ) => {
    let query: string = '';
    let data: any[] = [];
    let spatialFilter: any = getSpatialFilter(
      pFilters,
      props.allInseeCodesContract
    );
    if (spatialFilter.mode !== 'collectionPool') {
      let filtersIndus = defineDefinitionExpression(pFilters, 'indus', '');
      if (filtersIndus === '') {
        // no filters to add, only spatial filter
        query = spatialFilter.spatialFilter;
      } else {
        query = spatialFilter.spatialFilter + ' AND ' + filtersIndus;
      }
    } else {
      // collectionPool selected
      query = defineDefinitionExpression(pFilters, 'indus', '');
    }

    // get sections
    const formBodyToSend = createQueryIndus(
      query,
      'ActivityLabel',
      spatialFilter.inputGeom
    );
    data = await requestForIndus(formBodyToSend, 'ActivityLabel');
    setActivityOptions(data);
    return data;
  };

  // component did mount
  useEffect(() => {
    setAllInseeCodesContract(props.allInseeCodesContract);
    setCommuneOptions(props.allInseeCodesContract.concat(props.allBc));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getSection(
        {
          Color: colorFormated(fonctionnement),
          InseeCode: commune,
        },
        props.allInseeCodesContract
      ).then(() => {
        getOptionsActivity({
          Color: colorFormated(fonctionnement),
          InseeCode: commune,
          WarsmannNote: domestic,
          SectionLabel: section,
        }).then(() => {
          setLoading(false);
        });
      });
    }
  }, [commune, domestic, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  // set activity only section is selected
  useEffect(() => {
    if (section.code !== '') {
      setLoading(true);
      getOptionsActivity({
        Color: colorFormated(fonctionnement),
        InseeCode: commune,
        WarsmannNote: domestic,
        SectionLabel: section,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [section]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    props.parentCallback({
      Color: fonctionnement,
      InseeCode: commune,
      WarsmannNote: domestic,
      ActivityLabel: activity,
      SectionLabel: section,
    });
  }, [props.allBc]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='fonctionnement'>
          <Word
            value='Fonctionnement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-fonctionnement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorIndus}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              fonctionnement !== '' &&
                props.parentCallback({
                  Color: d,
                  InseeCode: commune,
                  WarsmannNote: domestic,
                  ActivityLabel: activity,
                  SectionLabel: section,
                });
              window.sessionStorage.setItem('indus_color', JSON.stringify(d));
            }}
            type='indus'
            sessionStorageName='indus_color'
          />
        </Container>
        {commune !== null && (
          <DoubleFilter
            module='indus'
            titleOne='Commune/Bassin de Col. :'
            filterNameOne='commune'
            filterOneOptions={communeOptions}
            titleTwo='Assimilés Domestiques :'
            filterNameTwo='domestic'
            filterTwoOptions={domesticOptionsIndus}
            parentCallbackOne={(d) => {
              setCommune(d);
              // reset activity and section
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'indus-filtre-section',
                setSectionOptions
              );
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'indus-filtre-activity',
                setActivityOptions
              );
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: d,
                WarsmannNote: domestic,
                ActivityLabel: {
                  name: '',
                  code: '',
                },
                SectionLabel: {
                  name: '',
                  code: '',
                },
              });
            }}
            parentCallbackTwo={(d) => {
              setDomestic(d);
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: commune,
                WarsmannNote: d,
                ActivityLabel: activity,
                SectionLabel: section,
              });
            }}
          />
        )}
        {section !== null && (
          <SingleFilter
            module='indus'
            title='Section :'
            filterName='section'
            filterOptions={sectionOptions}
            parentCallback={(d) => {
              // only use section filter if commune is selected
              setSection(d);
              // reset activity
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'indus-filtre-activity',
                setActivityOptions
              );
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: commune,
                WarsmannNote: domestic,
                ActivityLabel: {
                  name: '',
                  code: '',
                },
                SectionLabel: d,
              });
            }}
          />
        )}
        {activity !== null && (
          <SingleFilter
            module='indus'
            title='Activité Principale (selon base SIRENE) :'
            filterName='activity'
            filterOptions={activityOptions}
            parentCallback={(d) => {
              setActivity(d);
              // only use activity filter if section is selected
              if (d.code !== '') {
                props.parentCallback({
                  Color: fonctionnement,
                  InseeCode: commune,
                  WarsmannNote: domestic,
                  ActivityLabel: d,
                  SectionLabel: section,
                });
              }
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersIndus;
